import { useEffect, useState } from "react";

export type ConsentValue = "all" | "necessary";
export const CONSENT_KEY = "cookie_consent";
export const CONSENT_EVENT = "finable:cookie-consent-change";
export const CONSENT_OPEN_EVENT = "finable:cookie-consent-open";

export function getConsent(): ConsentValue | null {
  if (typeof window === "undefined") return null;
  const v = window.localStorage.getItem(CONSENT_KEY);
  return v === "all" || v === "necessary" ? v : null;
}

export function setConsent(value: ConsentValue) {
  window.localStorage.setItem(CONSENT_KEY, value);
  window.dispatchEvent(new CustomEvent(CONSENT_EVENT, { detail: value }));
}

export function openCookieBanner() {
  window.dispatchEvent(new CustomEvent(CONSENT_OPEN_EVENT));
}

export function useConsent(): ConsentValue | null {
  // Always start as null so first client render matches SSG output (no window).
  // Only read localStorage after mount to avoid hydration mismatches.
  const [consent, setState] = useState<ConsentValue | null>(null);
  useEffect(() => {
    setState(getConsent());
    const onChange = () => setState(getConsent());
    window.addEventListener(CONSENT_EVENT, onChange);
    window.addEventListener("storage", onChange);
    return () => {
      window.removeEventListener(CONSENT_EVENT, onChange);
      window.removeEventListener("storage", onChange);
    };
  }, []);
  return consent;
}
